import { useCallback } from "react";
import _ from "lodash";
import { imageFallback } from "helpers/product-helpers";
import { MEDIA_TYPE_IMAGE } from "constants/media";
import type { IScope } from "reducers/scope";
import { IProductMedia } from "constants/product-media";

export const useGetSafeImages = (scope: IScope) => {
    return useCallback(
        (media: IProductMedia) => {
            const fallback = [
                `//cdn1.nuorder.com/brands/${_.get(scope.brand, "settings.missing_logo_image")}.jpg`,
                imageFallback,
            ];
            return _.uniq(media && media.type === MEDIA_TYPE_IMAGE ? [media.source, ...fallback] : fallback);
        },
        [scope],
    );
};
